import React, { useState } from "react";
import { IllustratedBanner } from "@carfax/web-ui/components/IllustratedBanner";
import { ModuleCampaignBanner } from "@carfax/contentful/PageModularModule";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import router from "next/router";
import { VinSearchCtxProvider } from "components/VinSearch/VinSearchContext";
import VinSearch from "components/VinSearch/VinSearch";
import ModalWhereIsVin from "../ModalWhereIsVin";
import SampleReport from "components/SampleReport";
import { styles } from "./CampaignBanner.style";
import { useTranslations } from "next-intl";
import { Button } from "@carfax/web-ui/elements/Button";
import { ButtonVariants } from "@carfax/web-ui/shared/Button";

interface Props {
  module: ModuleCampaignBanner;
}

const CampaignBanner: React.FC<Props> = ({ module }) => {
  const {
    title,
    description,
    ctaButtonLabel,
    ctaButtonUrl,
    image,
    imageSize,
    anchorLinkLabel,
    partnerLogo,
    partnerNoteText,
    displayVinSearch,
    modalText,
    customPlaceholder,
    trustIconsText,
    trustIcons,
    withSearchButtonText,
    previewPageSlug,
    sampleReportText,
    bulletPoints,
    vinSearchPrimaryText,
    vinSearchSecondaryText,
  } = module;

  const [modalOpen, setModalOpen] = useState(false);
  const onClickWhereIsVin = (event: React.MouseEvent) => {
    event.preventDefault();
    setModalOpen(true);
  };
  const handleOnClick: React.MouseEventHandler = (e) => {
    if (ctaButtonUrl) {
      e.preventDefault();
      router.push(ctaButtonUrl);
    }
  };
  const vinSearchProps = {
    displayBelow: false,
    withSearchButtonText: withSearchButtonText,
    previewPageSlug: previewPageSlug ? previewPageSlug : "",
    customPlaceholder: customPlaceholder,
  };
  const t = useTranslations("common");

  return (
    <>
      <IllustratedBanner
        bulletPoints={bulletPoints}
        title={title}
        description={description ? documentToReactComponents(description) : null}
        ctaText={ctaButtonLabel}
        mainImage={image}
        imageSize={imageSize}
        ctaUrl={ctaButtonUrl}
        ctaOnClick={handleOnClick}
        additionalLinkUrl={t("business.contactLink")}
        additionalLinkText={anchorLinkLabel}
        partnerNote={partnerNoteText}
        partnerLogo={partnerLogo}
        trustIconsText={trustIconsText}
        trustIcons={trustIcons}
        vinSearch={
          displayVinSearch && (
            <VinSearchCtxProvider>
              <VinSearch {...vinSearchProps} />
            </VinSearchCtxProvider>
          )
        }
        modalText={
          !!modalText &&
          (displayVinSearch ? (
            <Button onClick={onClickWhereIsVin} variant={ButtonVariants.Text}>
              {modalText}
            </Button>
          ) : (
            <Button className={styles.button()} onClick={onClickWhereIsVin} variant={ButtonVariants.Text}>
              {modalText}
            </Button>
          ))
        }
        sampleReport={
          sampleReportText && (
            <SampleReport
              customButtonWrapperStyles={styles.button()}
              withButton
              inline={!!displayVinSearch}
              buttonVariant={ButtonVariants.Text}
              buttonText={sampleReportText}
            >
              {sampleReportText}
            </SampleReport>
          )
        }
        vinSearchPrimaryText={vinSearchPrimaryText}
        vinSearchSecondaryText={vinSearchSecondaryText}
      />
      {!!modalText && modalOpen && <ModalWhereIsVin modalOpen={modalOpen} setModalOpen={setModalOpen} />}
    </>
  );
};

export default CampaignBanner;
